import Component from './component';

export interface Props {
	onClose: () => void;
}

export default Component;